import React from 'react'
import PropTypes from 'prop-types'

// NOTIFY KAYLA IF YOU MAKE ANY CHANGES TO THIS FILE

class NumInputNoToolTip extends React.Component {
  constructor(props) {
    super(props)
    this.textInput = React.createRef()
    this.state = { firstChar: true }
  }
  focusTextInput = () => {
    this.textInput.current.focus()
  }
  selectAll = () => {
    this.textInput.current.setSelectionRange(0, this.props.value.length)
  }
  render() {
    const {
      className,
      min,
      max,
      precision,
      onChange,
      onBlur,
      value,
      ...rest
    } = this.props
    const neg =
      min === undefined || min === null || min < 0
        ? max < 0
          ? '-'
          : '-{0,1}'
        : ''
    const pattern =
      precision !== undefined && precision === 0
        ? '^' + neg + '[0-9]*$'
        : '^' + neg + '[0-9]*\\.{0,1}[0-9]*$'
    return (
      <input
        className={'num-input ' + (className !== undefined ? className : '')}
        ref={this.textInput}
        type="text"
        pattern={pattern}
        value={value}
        onChange={evt => {
          if (evt.target.validity.valid && onChange) {
            this.setState({ firstChar: false })
            onChange(evt)
          } else {
            if (this.state.firstChar) {
              evt.persist()
              setTimeout(() => {
                evt.target.setSelectionRange(0, evt.target.value.length)
              }, 50)
            }
          }
        }}
        onBlur={evt => {
          let newValue = 0
          if (evt.target.validity.valid) {
            newValue = parseFloat(evt.target.value)
            newValue = min !== undefined ? Math.max(min, newValue) : newValue
            newValue = max !== undefined ? Math.min(max, newValue) : newValue
            newValue =
              precision !== undefined && precision >= 0
                ? newValue.toFixed(precision)
                : newValue
          }
          const newEvent = {
            ...evt,
            target: {
              ...evt.target,
              value: newValue
            }
          }
          if (typeof onChange === 'function') {
            onChange(newEvent)
          }
          if (typeof onBlur === 'function') {
            onBlur(newEvent)
          }
        }}
        onFocus={evt => {
          this.setState({ firstChar: true })
          evt.target.setSelectionRange(0, evt.target.value.length)
        }}
        {...rest}
      />
    )
  }
}

NumInputNoToolTip.propTypes = {
  // Value in the input
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  // minimum allowed value
  min: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  // maximum allowed value
  max: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  // number of decimal places of accuracy to use (>= 0)
  precision: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  // should the field stretch full width or be be the equivalent of width = auto
  onChange: PropTypes.func,
  // callback on blur
  onBlur: PropTypes.func,
  // classes to apply
  className: PropTypes.string
}

export default NumInputNoToolTip
